import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Image } from '../../../';

const AuthorCard = ({ url, image, name, title }) => (
	<div className='authorCard border border-gray-10 bg-white shadow-[0_2px_4px_rgba(0,0,0,0.05)] hover:shadow-md'>
		<Link
			to={url}
			className='grid grid-cols-[56px_1fr] p-6 items-center gap-x-6 no-underline md:grid-cols-[60px_1fr] xl:grid-cols-[68px_1fr] xl:p-7'
		>
			{image && (
				<Image
					data={image}
					className='col-start-1 aspect-square w-full rounded-full'
				/>
			)}

			<div className='authorCard-info col-start-2'>
				{name && <p className='font-semibold'>{name}</p>}
				{title && <p className='mt-0.5 text-body-2'>{title}</p>}
			</div>
		</Link>
	</div>
);

AuthorCard.propTypes = {
	url: PropTypes.string,
	image: PropTypes.object,
	name: PropTypes.string,
	title: PropTypes.string,
};

export default AuthorCard;
